/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
    Grid,
    Avatar,
    Box,
    Button,
    Dialog,
    Slide,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
    Typography
} from "@mui/material";
import pr from "../lib/pr";
import get_token from "../lib/get_token";
import { useEffect, useState } from "react";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import { useHistory, Link } from "react-router-dom";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import moment from "moment";
import PickersDay from "@mui/lab/PickersDay";
import { useSetRecoilState } from "recoil";
import Swal from "sweetalert2";

const calTheme = createTheme({
    components: {
        MuiPickerStaticWrapper: {
            styleOverrides: {
                root: {
                    maxHeight: "280px",
                    height: "100%",
                },
            },
        },
    },
});

//const renderWeekPickerDay = (date, selectedDates, pickersDayProps) => {    
/*
var d = moment(date).format("D");    
var back = "white";
var color = "black";
var disable = "disable";
var width = "30px";
var height = "30px";
var margin = "0 5px";
// console.log(d);
// var margin = `${props => props.hiddenDaySpacingFiller?'0 5px':'0 10px'}`;
// if(d%2===0){color="green"};
if (d == 8) {
    back = "#0092a2";
    color = 'white';
}
if (d == 3 || d == 15) {
    back = "#f2b4cd";
    color = "white";
}

if (d != 3 || d != 15 || d == 8) {
}
return (
    <PickersDay
        {...pickersDayProps}
        sx={{
            ["&&.Mui-selected"]: {
                background: "none",
                color: "black",
                width: "30px",
                height: "30px",
                margin: "0 5px",
            },
            "&.MuiPickersDay-today": {
                border: "none",
                color: "black",
                width: "30px",
                height: "30px",
                margin: "0 5px",
            },
            margin: `${(props) =>
                props.hiddenDaySpacingFiller ? "0 5px" : "0 10px"}`,
        }}
        css={css`
    background: ${back};
    color: ${color};
    width: ${width};
    height: ${height};
    margin: ${margin};
  `}
    />
);
*/
//};

function MypageLoggedReservation(props) {

    // 예약 리스트
    // const [reserves, setReserves] = useState(
    //     [
    //         {
    //             id: 0,
    //             title: 'DNS',
    //             name: 'Aurora',
    //             day: '2022-03-09',
    //             time: '오후 2:00',
    //         },
    //         {
    //             id: 1,
    //             title: 'CFSC',
    //             name: 'Megan',
    //             day: '2022-03-11',
    //             time: '오전 10:00',
    //         },
    //         {
    //             id: 2,
    //             title: 'DNS',
    //             name: 'Conelly',
    //             day: '2022-03-14',
    //             time: '오후 6:00',
    //         },
    //     ]
    // )

    const { login } = props;
    const [loaded, setLoaded] = useState(false);
    const history = useHistory();
    const [sdate, setSdate] = useState(moment().format("YYYY-MM-01"));
    const lastdate = new Date(moment(sdate).add(1, 'year').add(-1, 'day').format("YYYY-MM-DD"));
    const firstdate = new Date(moment(sdate).add(-1, 'year').add(-1, 'day').format("YYYY-MM-DD"));
    const minDate = new Date(moment().add(-1, "years"));
    const maxDate = new Date(moment().add(+1, "years"));
    const token = get_token();
    const [rows, setRows] = useState([]); // 예약현황
    const [next, setNext] = useState({
        class_time: "",
      });

    const today = new Date(moment())
    // console.log(today)
    // 예약 데이타    
    const load_data = async () => {
        let post_data = {
            token: token,
            mcd: login.mcd,
            cid: configState.cid,
            level: login.level,
            sdate: sdate
        }
        let result = await axios.post(configState.api+"/gympass/my_reservation", post_data);
        if (result.data.success === 1) {
          setRows(result.data.rows);
        }
    }
    useEffect(() => {
        if(login.mcd !== ""){
            load_data();
        }
        
    }, [sdate])

    // 일정 가져오기 (달력 그리기)
    const renderWeekPickerDay = (date, selectedDates, pickersDayProps) => {
        let d = moment(date).format("D");
        let ym1 = moment(date).format("YYYY-MM-01");
        let ym2 = moment(sdate).format("YYYY-MM-01");

        // 같은달?
        // 지난달 다음달 숫자 빼기 위해서
        let this_month = false;
        if (ym1 === ym2) {
            this_month = true;
        }

        // 예약이 있나?
        let is_reserve = false;
        let idx = rows.findIndex((el) => moment(el.class_date).format('DD') === moment(date).format('DD'))
        if (idx > -1) {
            is_reserve = true;
        }

        return (
            <Box key={d} display="flex" alignItems="center" justifyContent="center"
                sx={{ width: 40, height: 30 }}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="cetner">
                    {this_month && is_reserve && <Typography display="flex"
                        alignItems="center"
                        justifyContent="center" fontSize={12} sx={{ backgroundColor: "#0092a2", color: 'white', fontWeight: 'bold', width: 30, height: 30, borderRadius: "50%" }}>{d}
                    </Typography>}
                    {this_month && !is_reserve && <Typography display="flex"
                        alignItems="center"
                        justifyContent="center" fontSize={12} sx={{ width: 30, height: 30, borderRadius: "50%" }}>{d}
                    </Typography>}
                    {!this_month && <Typography display="flex" alignItems="center" justifyContent="center" fontSize={12} sx={{ width: 30, height: 30, borderRadius: "50%" }}></Typography>}
                </Box>
            </Box>
        );
    }

    const onCancel = (seq) => { // 예약취소
      Swal.fire({
        title: "예약을 취소 하시겠습니까?",
        showConfirmButton: true,
        showCancelButton: true,
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            let result = await axios.post(configState.api + "/gympass/reservation_cancel", {
              token: token,
              mcd: login.mcd,
              level: login.level,
              cid: configState.cid,
              seq:seq,
            });
            if (result.data.success === 1) {
              Swal.fire('취소 되었습니다.')
              .then(() => {
                   load_data();
              })
              .catch(e => Swal.fire(e));
            } else {
              Swal.fire(result.data.msg);
            }
          }
        })
        .catch((e) => Swal.fire(e));      
    } 

    return (
        <Grid
            container
            // display="block"
            width="100%"
            direction='column'
            justifyContent='center'
            alignItems='center'
            position='absolute'
            top='120px'
            // overflow='hidden'
            >
            {/* <Box sx={{ height: '120px' }}></Box> */}
            {/* 예약없슴 */}
            {rows.length>=0&&
            <LocalizationProvider
                dateAdapter={AdapterDateFns}
                locale={ko}
            >
                <ThemeProvider theme={calTheme}>
                    <StaticDatePicker
                        autoOk
                        views={["year", "month", "day"]}
                        minDate={minDate}
                        maxDate={maxDate}
                        displayStaticWrapperAs="desktop"
                        value={sdate}
                        onChange={(newValue) => { setSdate(moment(newValue).format("YYYY-MM-01")) }}
                        renderInput={(params) => <TextField {...params} />}
                        날짜에 badge로 표시하기
                        renderDay={renderWeekPickerDay}
                        onMonthChange={(newValue) => { setSdate(moment(newValue).format("YYYY-MM-01")) }}
                    ></StaticDatePicker>
                </ThemeProvider>
            </LocalizationProvider>
            }
            {
                rows.length === 0 &&
            // next.class_time === "" &&
                <>
                    <Box
                        sx={{ minHeight: 80, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                        <Typography>
                            {moment(sdate).format('M')}월에는 예약이 없습니다.
                        </Typography>
                    </Box>

                    <Button
                        variant="contained"
                        component={Link}
                        to='/book'
                        sx={{
                            background: '#0092a2',
                            width: '320px',
                            marginTop: '10px'
                        }}>수업예약</Button>
                </>
            }

            {/* 예약있슴 */}
            {/* {minDate<=rows.class_date<=maxDate && */}
            
            {
            // next.class_time !== "" &&
            // rows.class_date<=today &&
            // rows.class_date!=="" &&
            
            rows.length > 0 &&
             rows.map((item, index) => {                
                
                // 예약취소
                let cancel_tf = false;                
                if( moment(item.class_date).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) { // 당일취소 불가
                  cancel_tf = true;
                }

                return (
                    <Box
                    key={index}>
                        <Box
                            sx={{
                                width: '320px',
                                mb: 2,
                                background: '#f1f2f2',
                                padding: '15px',
                            }}>
                            <Box sx={{ fontWeight: "bold" }}>{item.class_name}</Box>
                            <Box>{item.tname}</Box>
                            <Box>{item.class_date} {item.class_hour}</Box>
                            { cancel_tf &&                        
                            <Box>
                              <Button variant="contained" onClick={()=>onCancel(item.seq)}>예약취소</Button>
                            </Box> }

                        </Box>
                        
                    </Box>
                )
            })}

            <Box sx={{ height: "100px" }}></Box>
        </Grid>
    )
}

export default MypageLoggedReservation;